/* eslint-disable react/prop-types */
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { RiAlertFill, RiAlertLine } from 'react-icons/ri';

export const isSelectedLine = (selectedLines, line) =>
  selectedLines.some((selectedLine) => selectedLine.id === line.id);

export const areAllLinesSelected = (allLines, selectedLines) =>
  allLines?.every((line) => isSelectedLine(selectedLines, line));

export const selectLine = (setSelectedLines, selectedLines, rowData) => {
  if (isSelectedLine(selectedLines, rowData)) {
    setSelectedLines((prevSelectedLines) =>
      prevSelectedLines.filter((selectedLine) => selectedLine.id !== rowData.id)
    );

    return;
  }

  setSelectedLines((prevSelectedLines) => [...prevSelectedLines, rowData]);
};

export const selectAllLines = (setSelectedLines, selectedLines, allLines) => {
  if (areAllLinesSelected(allLines, selectedLines)) {
    setSelectedLines([]);

    return;
  }

  setSelectedLines(allLines);
};

export const getCertStateIcon = (estadoCert) => {
  if (estadoCert === 4) {
    return (
      <RiAlertFill
        color="#FFFFFF"
        style={{
          backgroundColor: '#FF6666',
          height: '30px',
          width: '30px'
        }}
      />
    );
  }

  // If estadoCert === 5, but keeps by default to always return a value
  return <RiAlertLine color="#219E66" style={{ width: '30px', height: '30px' }} />;
};

export const getColumns = (allLines, selectedLines, setSelectedLines) => [
  {
    Header: (
      <input
        checked={areAllLinesSelected(allLines, selectedLines)}
        onChange={() => selectAllLines(setSelectedLines, selectedLines, allLines)}
        type="checkbox"
      />
    ),
    accessor: 'none2',
    hideSort: true,
    style: { fontWeight: 'bold', width: '40px' },
    Cell: ({ row }) => (
      <input
        checked={isSelectedLine(selectedLines, row.original)}
        onChange={() => selectLine(setSelectedLines, selectedLines, row.original)}
        type="checkbox"
      />
    )
  },
  {
    Header: 'Posición',
    accessor: 'descripcionPosicionYClick',
    hideSort: true,
    style: { fontWeight: 'bold' },
    Cell: ({ row }) => (
      <OverlayTrigger
        delay={{
          show: 250,
          hide: 400
        }}
        overlay={(props) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <Tooltip id="button-tooltip" {...props}>
            {row?.original?.descripcionPosicionSap}
          </Tooltip>
        )}
        placement="top"
      >
        <span>{row.original.descripcionPosicionYClick}</span>
      </OverlayTrigger>
    )
  },
  {
    Header: 'Línea',
    accessor: 'descripcionLineaYClick',
    hideSort: true,
    style: { fontWeight: 'bold' },
    Cell: ({ row }) => (
      <OverlayTrigger
        delay={{
          show: 250,
          hide: 400
        }}
        overlay={(props) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <Tooltip id="button-tooltip" {...props}>
            {row?.original?.descripcionLineaSap}
          </Tooltip>
        )}
        placement="top"
      >
        <span>{row.original.descripcionLineaYClick}</span>
      </OverlayTrigger>
    )
  },
  {
    Header: 'Cant. Reg.',
    hideSort: true,
    accessor: 'cantReg',
    style: { fontWeight: 'bold' }
  },
  {
    Header: 'Cant. Cert.',
    hideSort: true,
    accessor: 'cantCert',
    style: { fontWeight: 'bold' }
  },
  {
    Header: 'PxQ',
    hideSort: true,
    accessor: 'pxQ',
    style: { fontWeight: 'bold' },
    Cell: ({ value }) => <span>$ {value}</span>
  },
  {
    Header: '',
    accessor: 'estadoCert',
    hideSort: true,
    Cell: ({ value }) => (
      <button className="inspector_work_button_cert_state" type="button">
        {getCertStateIcon(value)}
      </button>
    ),
    style: {
      width: '50px'
    }
  },
  {
    Header: 'Cant. Reg. Type',
    accessor: 'cantRegType',
    style: { fontWeight: 'bold' },
    Cell: () => ''
  },
  {
    Header: 'Tarifa Vigente',
    accessor: 'tarifaVigente',
    style: { fontWeight: 'bold' },
    Cell: (options) => {
      options.setHiddenColumns(['tarifaVigente', 'cantRegType']);

      return '';
    }
  }
];
